module.exports = __webpack_public_path__ + "img/Lei-li-formal-960w.74f20ac.jpeg";